import { configureStore } from '@reduxjs/toolkit';

import { authApi } from './api/auth';
import { userApi } from './api/user';
import { sensorsApi } from './api/sensors';
import { workspacesApi } from './api/workspaces';
import { catalogApi } from './api/catalog';
import { notesApi } from './api/notes';
import { fieldsApi } from './api/fields';
import { membershipsApi } from './api/memberships';
import { weatherApi } from './api/weather';
import { notificationsApi } from './api/notifications';
import { notificationsSlice } from './slices/notifications';

import { authSlice } from './slices/auth';
import { uiSlice } from './slices/ui';
import { sensorsSlice } from './slices/sensors';
import { workspacesSlice } from './slices/workspaces';
import { catalogSlice } from './slices/catalog';
import { fieldsSlice } from './slices/fields';
import { notesSlice } from './slices/notes';

import { authMiddleware } from './middleware/auth';

export const store = configureStore({
  reducer: {
    // api
    [authApi.reducerPath]: authApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [sensorsApi.reducerPath]: sensorsApi.reducer,
    [workspacesApi.reducerPath]: workspacesApi.reducer,
    [catalogApi.reducerPath]: catalogApi.reducer,
    [notesApi.reducerPath]: notesApi.reducer,
    [fieldsApi.reducerPath]: fieldsApi.reducer,
    [membershipsApi.reducerPath]: membershipsApi.reducer,
    [weatherApi.reducerPath]: weatherApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    // state
    auth: authSlice.reducer,
    ui: uiSlice.reducer,
    sensors: sensorsSlice.reducer,
    workspaces: workspacesSlice.reducer,
    catalog: catalogSlice.reducer,
    notes: notesSlice.reducer,
    fields: fieldsSlice.reducer,
    notifications: notificationsSlice.reducer,
  },
  middleware: (getDefaultMiddlware) => [
    ...getDefaultMiddlware(),
    // api
    authApi.middleware,
    userApi.middleware,
    sensorsApi.middleware,
    workspacesApi.middleware,
    catalogApi.middleware,
    notesApi.middleware,
    fieldsApi.middleware,
    membershipsApi.middleware,
    weatherApi.middleware,
    notificationsApi.middleware,
    // custom
    authMiddleware.middleware,
  ],
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
